import {Outlet, redirect} from "react-router-dom";
import Header from "../../components/header/header";
import LoginHeader from "../../components/loginHeader/loginHeader";
import {useContext} from "react";
import AppContext from "../../contexts/appContext/app.context";

const Home = () => {
    const appCtx = useContext(AppContext);

    return(
        <>
            {!appCtx.isLoggedIn &&
                <LoginHeader/>
            }
            {appCtx.isLoggedIn &&
                <Header/>
            }
            <div className="margin-b-50"><Outlet/></div>
        </>
    )
}

export default Home;
